<cm-button
  (click)="open()"
  label="Manage payment account"
  appearance="primary"
></cm-button>
